var Raphael = require('raphael');
require('../modules/FV/extension/raphael/raphael');


// Custom fork of Raphael Giraffe for drawing floating reason codes in this application.
// Find example and original source at http://dmitrybaranovskiy.github.io/raphael/graffle.html.
// Main changes:
// - Not using bounding boxes: assumes the objects passed in are paths with transforms.
// - Connections are made at points, not 'ports' which could be an edge of the shape.
// - Only interested in straight lines (no bezier curves)
// - Don't add/subtract pixels when derives the port locations; have them exact.
// This is working -- if performance becomes an issue there is room for optimization.

Raphael.fn.connection = function(redaction, codeBox, line, bg) {

    if (redaction.line && redaction.from && redaction.to) {
        line = redaction;
        redaction = line.from;
        codeBox = line.to;
    }

    var codeBoxPts = codeBox.getPathCoordinates(1),
        redactionPts = redaction.getPathCoordinates(1),
        nRedactionPts = redactionPts.length,
        dists = {}, // keys: box pt array index; values: array of distances of other shape points to the box
        minDists = {}; // box pt array index by array ( indexOfMinDist, minDist )

    //  Handle in case the codeBoxPts have yet to be defined to prevent error.
    ( codeBoxPts.length < 1 ) && codeBoxPts.push( {x:0, y:0} );

    for ( var c=0; c<codeBoxPts.length; c++ ) {

        var aDistToOtherPts = [];

        for (var r=0; r<nRedactionPts; r++) {
            aDistToOtherPts.push( distBetweenPoints( codeBoxPts[c], redactionPts[r] ) );
        }

        dists[c] = aDistToOtherPts;

        // Need the index and the distance -- here stored in array
        // Room for optimization: could only have pt index min distance obj and replace it if a subsequent one is smaller, etc
        var minDist = Math.min.apply( Math , dists[c] );

        minDists[c] = {
            idx: dists[c].indexOf(minDist),
            dist: minDist
        };
    }

    // Get the min pt and it's min distance to get its 'pair' point to draw the line.

    var theMinDisIdx = 0,
        theMinDist = minDists[0];

    for (k in minDists) {
        // Extra first loop: suboptimal ...
        if (minDists[k].dist < theMinDist.dist) {
            theMinDisIdx = k;
            theMinDist = minDists[k];
        }
    }

    var codePt = codeBoxPts[theMinDisIdx],
        redactionPt = redactionPts[theMinDist.idx],
        path = ["M", codePt.x.toFixed(3), codePt.y.toFixed(3), "L", redactionPt.x.toFixed(3), redactionPt.y.toFixed(3)].join(",");

    if (line && line.line) {

        line.bg && line.bg.attr({path: path});
        line.line.attr({path: path});

    } else {

        var color = typeof line == "string" ? line : "#000";

        return {
            bg: bg && bg.split && this.path(path)
                .attr( {stroke: bg.split("|")[0], fill: "none", "stroke-width": bg.split("|")[1] || 3} ),
            line: this.path(path).attr({stroke: color, fill: "none"}),
            from: redaction,
            to: codeBox
        };
    }

};


function distBetweenPoints(pt1, pt2) {
    var a = pt1.x - pt2.x,
        b = pt1.y - pt2.y;
    return Math.sqrt( a*a + b*b );
}


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/raphael.connection.js
 ** module id = 251
 ** module chunks = 0
 **/